import React from 'react';
import { useUnreadState } from '@app/unread-indicator';
import { UnreadDot } from './UnreadDot';

export interface UnreadDotCellProps {
  id: string;
  firstPublishedAt: string;
}

export const UnreadDotCell: React.FC<UnreadDotCellProps> = ({
  id,
  firstPublishedAt,
}) => {
  const { isUnread, markSeen } = useUnreadState({ id, firstPublishedAt });

  if (!isUnread) {
    return null;
  }

  return <UnreadDot onClick={markSeen} testId={`unread-dot-${id}`} />;
};

export default UnreadDotCell;
